import React, { Component } from 'react'
import { connect } from 'react-redux'
import queryString from 'query-string'
import { captureException } from '@sentry/browser'

import { fetchPermissions } from 'actions/permissionsActions'
import { fetchProfile } from 'actions/profileActions'
import { enqueueError } from 'lib/components/GlobalNotifications'
import { fetchLoggedIn } from 'lib/actions/loggedInActions'
import { SUCCESS, getRequestStatus } from 'lib/selectors/requestStateSelectors'
import { isImpersonating } from 'selectors/impersonationSelectors'
import { retryFetch } from 'utils/util'

import FsmHandler from './FsmHandler'
import CustomerHandler from './CustomerHandler'

class UserHandler extends Component {
  constructor(props) {
    super(props);
    this.message = 'Please try again. If problem persists, please contact LIC on 0800 2 MINDA (0800 264 632).'
    this.ctaLabel = props.isImpersonating ? 'Back to customer search' : 'Reload page'
    this.ctaLink = props.isImpersonating ? global.config.LIC_CUSTOMER_ENDPOINT : global.config.SHOP_FRONTEND_ENDPOINT
  }

  componentDidMount() {
    let { enqueueError, fetchLoggedIn } = this.props

    // GET lic-ui-proxy/api/logged_in
    retryFetch(fetchLoggedIn)
      .catch(() => {
        enqueueError({
          message: 'We were unable to check your logged in status. You can browse but will be unable to place orders. ' + this.message,
          ctaLabel: this.ctaLabel,
          ctaLink: this.ctaLink,
        })
      })
  }

  componentDidUpdate(prevProps) {
    let {
      enqueueError,
      fetchPermissions,
      fetchProfile,
      isLoggedIn,
      profile,
      profileRequestStatus,
    } = this.props

    if (!prevProps.isLoggedIn && isLoggedIn && !profile && !profileRequestStatus) {
      // GET profile/api/profiles/for_me
      retryFetch(fetchProfile)
        .catch(err => {
          if (err.response?.status === 404) {
            let redirectParams = {
              redirect_url: global.config.SHOP_FRONTEND_ENDPOINT,
              redirect_label: 'Store',
            }
            window.location = `${
            global.config.LIC_CUSTOMER_ENDPOINT
          }/profile/create?${queryString.stringify(redirectParams)}`
          } else {
            enqueueError({
              message: 'We were unable to fetch your profile. ' + this.message,
              ctaLabel: this.ctaLabel,
              ctaLink: this.ctaLink,
            })
          }
        })
    }

    if (!prevProps.profile && profile) {
      // Find out whether user has permission to impersonate
      // GET lic-ui-proxy/api/permitted_activity?activity=licshopprivilegeimpersonationsimpersonate
      retryFetch(fetchPermissions)
        .catch(err => {
          // Send error to Sentry so we can monitor how often this occurs, but don't display error
          // message because if user is customer, they can go ahead and place order even if this
          // request fails. Staff can't, but they'll see other error messages from
          // CustomerContextHandler that inform them they can't place orders (No billing entity
          // found. No herds found.)
          captureException(err)
        })
    }
  }

  render() {
    let {
      isImpersonating,
    } = this.props
    return isImpersonating ? <FsmHandler /> : <CustomerHandler />
  }
}

const mapDispatchToProps = {
  enqueueError,
  fetchLoggedIn,
  fetchPermissions,
  fetchProfile,
}

export { UserHandler }
export default connect(state => {
  return {
    isImpersonating: isImpersonating(state),
    isLoggedIn: state.loggedIn.data.isLoggedIn,
    profile: state.profile.data,
    profileRequestStatus: getRequestStatus(state.profile.requestState),
  }
}, mapDispatchToProps)(UserHandler)
